module.exports = __webpack_public_path__ + "static/img/10.b325871.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/10/zh/10.png
// module id = z7Q8
// module chunks = 0